function adjustFooterBlockHeight() {
  document.querySelectorAll('.footer-block').forEach((footerBlock) => {
    const heading = footerBlock.querySelector('.footer-block__heading');
    const content = footerBlock.querySelector('.footer-block__details-content');
    let isActive = footerBlock.classList.contains('active');
    const setBlockHeight = (activeStatus) => {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      const height = isDesktop ? 'fit-content' : (activeStatus ? `${content.scrollHeight + 40}px` : '40px');
      footerBlock.style.height = height;
    };
    const resizeHandler = () => {
      window.requestAnimationFrame(() => setBlockHeight(isActive));
    };
    if (isActive) {
      window.requestAnimationFrame(() => setBlockHeight(true));
    } else {
      footerBlock.style.height = '40px';
    }
    heading.addEventListener('click', () => {
      isActive = footerBlock.classList.toggle('active');
      if (isActive) {
        footerBlock.style.height = '40px';
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            setBlockHeight(isActive);
          });
        });
      } else {
        window.requestAnimationFrame(() => {
          setBlockHeight(isActive);
        });
      }
    });
    window.addEventListener('resize', resizeHandler);
  });
}
adjustFooterBlockHeight();